import React, { useState } from 'react';
import { Link } from "react-router-dom";
import textlogo from "./assets/still_logo_maroon.png";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className="home-header">
      <nav className="home-navbar">
        <img
          src={textlogo}
          alt="STILL - Own Your Pace"
          className= "brand"
        />

        {/* Left Links */}
        <ul className="still-nav-left">
          <li><Link to= '../shop'>Shop</Link></li>
          <li><a href="#top-picks">Top Picks</a></li>
          <li><a href="../blog">Blogs</a></li>
        </ul>

          {/* Center Brand */}
          <div className="still-brand">
            <img
              src={textlogo}
              alt="STILL - Own Your Pace"
            />
          </div>

        {/* Right Links */}
        <ul className="still-nav-right">
          <li><a href="#about-us">About Us</a></li>
          <li><Link to= '../tracking'>Track Order</Link></li>
          <li><Link to= '../contact'>Contact</Link></li>
        </ul>

        {/* Hamburger icon (mobile only) */}
        <div className="hamburger" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* Overlay menu (mobile only) */}
        <div className={`nav-overlay ${isOpen ? 'open' : ''}`}>
          <button className="close-btn" onClick={toggleMenu}>✕</button>
          <ul className="nav-overlay-links">
            <li><a href="#index" onClick={toggleMenu}>Home</a></li>
            <li><Link to= '../shop' onClick={toggleMenu}>Shop</Link></li>
            <li><a href="#top-picks" onClick={toggleMenu}>Top Picks</a></li>
            <li><Link to= '../blog' onClick={toggleMenu}>Blogs</Link></li>
            <li><a href="#about-us" onClick={toggleMenu}>About Us</a></li>
            <li><Link to= '../tracking' onClick={toggleMenu}>Track Order</Link></li>
            <li><Link to= './contact' onClick={toggleMenu}>Contact</Link></li>
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Header;
